if($('#legal_age').length){
    if (typeof window.sessionStorage != undefined) {
        if (!sessionStorage.getItem('legal_age_session')) {
            setTimeout(()=>{
                $('#legal_age').fadeIn(500).addClass('active');
            }, 3000);
            $('#legal_accept').click(function(){
                console.log('Close notification session storage');
                sessionStorage.setItem('legal_age_session', true);
                sessionStorage.setItem('storedWhen', (new Date()).getTime());
                $('#legal_age').fadeIn(300).addClass('hide').removeClass('active');
            });
        }else{
            console.log('Logged in session storage')
            $('#legal_age').addClass('hide').removeClass('active');
        }
    }
}